/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Feature_Audit_LogsInputs */



/**
* | output |
* | --- |
* | "Audit Logs" |
*
* @param {Plan_Gate_Feature_Audit_LogsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_feature_audit_logs = /** @type {((inputs?: Plan_Gate_Feature_Audit_LogsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Feature_Audit_LogsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Protokolle")
	return /** @type {LocalizedString} */ ("Audit Logs")
});